import { jsxs as p, jsx as t } from "react/jsx-runtime";
import N from "classnames";
import i from "./index.es2436.js";
import { ColorIndicator as v } from "./index.es32.js";
import { Divider as T } from "./index.es24.js";
import { BodyText as j } from "./index.es505.js";
const F = ({
  content: d,
  entityColor: s,
  colorIndicator: e,
  hideDivider: f,
  title: x,
  testId: m
}) => {
  const h = !s && !e && !f, a = e || s !== void 0, D = N(i.header, {
    [i.withEntityIndicator]: !!a,
    [i.withDivider]: h
  });
  return /* @__PURE__ */ p("div", { "data-testid": m, children: [
    /* @__PURE__ */ p("div", { className: D, children: [
      s ? /* @__PURE__ */ t(
        v,
        {
          entityColor: s,
          testId: (e == null ? void 0 : e.testId) || m + "-color-indicator",
          ...e
        }
      ) : e != null && e.color ? /* @__PURE__ */ t(
        v,
        {
          testId: (e == null ? void 0 : e.testId) || m + "-color-indicator",
          ...e
        }
      ) : void 0,
      /* @__PURE__ */ t(j, { variant: "bold", "data-testid": m + "-title", children: x }),
      h && /* @__PURE__ */ t(T, {})
    ] }),
    d
  ] });
};
export {
  F as FreeTextTooltipContent
};
//# sourceMappingURL=index.es137.js.map
